// apps/web/src/lib/socket-client.ts
import { io, Socket } from 'socket.io-client'
import { SOCKET_URL } from './constants'
import type { ServerToClientEvents, ClientToServerEvents } from '@viecxanh/chat-shared'

type ChatSocket = Socket<ServerToClientEvents, ClientToServerEvents>

let _socket: ChatSocket | null = null

export function getSocket(): ChatSocket {
  if (!_socket) {
    _socket = io(SOCKET_URL, {
      withCredentials: true, // send HttpOnly cookie in WS handshake
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 30_000,
      randomizationFactor: 0.5,
      timeout: 10_000,
      autoConnect: false, // call connect() explicitly after auth check
    }) as ChatSocket
  }
  return _socket
}

export function disconnectSocket(): void {
  if (_socket) {
    _socket.disconnect()
    _socket = null
  }
}
